import { Component, OnInit } from '@angular/core';
import { SponsorService } from 'src/app/services/sponsor.service';
import { Sponsor } from 'src/app/model/sponsor';

@Component({
  selector: 'sponsor-list',
  templateUrl: 'sponsor-list.html',
  styles: ["img { display: block; margin: 0 auto; width: 75%; padding: 0.75rem }"]
})

export class SponsorListComponent implements OnInit {
  
  ngOnInit(): void {
    this.getSponsors();
  }

  constructor(private sponsorService: SponsorService) { }

  sponsors: Sponsor[] = null;
  
  getSponsors(): void {
    this.sponsorService.getSponsors().subscribe(sponsors => this.sponsors = sponsors);
  }
}
